import m from "./../../../dist/es2015/locales/pl_PL.js";
export const am5locales_pl_PL = m;